import { fetchData, apiURL } from './api_helper';

const createExchangeType = payload => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}exchangeTypes`;
  fetchData(endpointURL, 'post', payload).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const updateExchangeType = (id, payload) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}exchangeTypes/${id}`;
  fetchData(endpointURL, 'post', payload).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const fetchExchangeTypes = () => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}exchangeTypes`;
  fetchData(endpointURL, 'get').then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const makeExchange = payload => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}exchanges`;
  fetchData(endpointURL, 'post', payload).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const fetchOpenExchanges = () => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}exchanges/open`;
  fetchData(endpointURL, 'get').then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const fetchExchanges = id => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}exchanges/${id}`;
  fetchData(endpointURL, 'get').then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const performExchange = exchangeId => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}exchanges/${exchangeId}/perform`;
  fetchData(endpointURL, 'post', {}).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const deleteExchangeType = type => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}exchangeTypes/${type}`;
  fetchData(endpointURL, 'delete', {}).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));


export default {
  createExchangeType,
  updateExchangeType,
  makeExchange,
  fetchExchangeTypes,
  fetchOpenExchanges,
  fetchExchanges,
  performExchange,
  deleteExchangeType,
};
